module.exports = __webpack_public_path__ + "static/media/stepper-publish-icon-active.b486f0d5.svg";